import { createSlice } from '@reduxjs/toolkit';

const contextSlice = createSlice({
  name: 'context',
  initialState: {
    user: null,
  },
  reducers: {
    setContext: (_state, action) => action.payload,
    setUsageLimitHit: (state) => { state.usageLimitHit = true; },
  },
});

export const { setContext, setUsageLimitHit } = contextSlice.actions;
export default contextSlice.reducer;
